import { API_HOST } from "./Host";
import { API } from "./Host";
export const URL = {
    getListProjet: API + 'api/categoryprojects',
    getListCategoryAdmin: API + 'api/admin/list-category',
    getListBienAdmin: API + 'api/admin/list-bien',
    addCategoryAdmin: API + 'api/admin/save-category',
    addBienAdmin: API + 'api/admin/save-bien',
    updateCategoryAdmin: API + 'api/admin/edit-category/',//{id}
    updateBienAdmin: API + 'api/admin/edit-bien/',//{id}
    setUpdateCategoryAdmin: API + 'api/admin/update-category',
    setUpdateBienAdmin: API + 'api/admin/update-bien',
    getListBien: API + 'api/biens/category-bien/',
    postData: API + 'api/projects',
    auth: API + 'api/login',
    getListProjetUser: API + 'api/project/list-per-user/',
    getDetailProjet: API + 'api/project/detail-project/',
    updateProjet: API + 'api/project/update/',
    getListProjetAdmin: API + 'api/admin/project/list-project',
    postForgotPassword: API + 'api/forgot-password',
    postNewPassword: API + 'api/save-new-password',
    // deleteProjet: API + 'api/admin/project/delete-project/', //{id}
    setStateProjet: API + 'api/admin/project/change-state', //{id}, {state}
    setStageProjet: API + 'api/admin/project/change-stage', //{id}, {state}
    updateInfosComplémentaire: API + 'api/project/detail-project/add-detail',
    uploadFile: API + 'api/project/detail-project/upload-file',

    // professionnel
    getListProfession: API + 'api/list-profession',
    getListServiceProfession: API + 'api/list-service',
    postDataProfessionnel: API + 'api/create-professionnel-account',
    getPreference: API + 'api/professionnel/get-preferences/', //{id}
    setPreference: API + 'api/professionnel/set-preferences/', //{id}
    updateProfessionnel: API + 'api/professionnel/store-details/', //{id}
    getInfosUser: API + 'api/professionnel/get-info/', //{id}
    getStatusProfessionnel: API + 'api/professionnel/get-status-register/', //{id}
    getListOffreProfessionnel: API + 'api/professionnel/mes-offres/',//{id}
    getListProjetAccepter: API + 'api/professionnel/mes-projets/',//{id}
    postAccepterOffre: API + 'api/professionnel/mes-offres/validate/',//{offre_id},{user_id }
    postDeclineerOffre: API + 'api/professionnel/mes-offres/refused/',//{offre_id},{user_id }
    postCreateZoneIntervention: API + 'api/professionnel/store-intervention/',//{user_id }
    getZoneIntervention: API + 'api/professionnel/zone-intervention/',//{user_id }
    postUpdateZone: API + 'api/professionnel/update-intervention/',//{zone_id }
    postDeleteZone: API + 'api/professionnel/delete-intervention/',//{zone_id }
    getListClientForPro: API + 'api/professionnel/list-user-Pro/',//{user_id }

    // admin 
    getListUser: API + 'admin/account/lists',
    getListRole: API + 'api/list-role',
    postUserbyAdmin: API + 'admin/account/create-new',
    postOffrebyAdmin: API + 'admin/account/create-offre',
    getListOffreProfessionelbyAdmin: API + 'admin/account/liste-offre-envoyer',
    postDeleteOffreByAdmin: API + 'admin/supprimer/offre/', //{projet_id}
    postDeleteProjetByAdmin: API + 'admin/supprimer/projet/', //{{offre_id}}

    postModifyUser: API + 'api/admin/modify-user',//{user_id }
    postDeleteUser: API + 'api/delete-client/',//{user_id }
    postCheckUserIdentity: API + 'api/admin/check-user',

    // devis
    getListProduit: API + 'api/produit',
    postProduitbyAdmin: API + 'api/produit',
    getOneProduitByid: API + 'api/produit/find/',//{id}
    postUpdateProduit: API + 'api/produit/update/',//{id}
    postDeleteProduit: API + 'api/produit/delete/',//{id}
    createDevis: API + 'api/devis',
    getListDevis: API + 'api/liste-devis/',//{id} //\?is_validate=1
    getListDevisAdmin: API + 'api/liste-devis',//\?admin_id=1
    postSendMailDevis: API + 'api/send-devis-email/',//{id}
    getDetailsDevisFromId: API + 'api/get-details-devis/',//{devis_id}
    postUpdateDevis: API + 'api/update-devis/',//{devis_id}
    postSignDevis: API + 'api/sign-devis/',//{devis_id}
   
    //facture
    postGenerateInvoicePerDevis: API + 'api/facture',
    getListFacture: API + 'api/liste-facture',//{id}


    //client adobe sign
    getAccessTokenDev: 'https://api.eu1.documents.adobe.com/oauth/v2/refresh',
    acceptSignDocumentAdobe: 'https://api.eu1.adobesign.com/api/rest/v6/agreements',
    createDocumentAdobeSign: API + 'api/sign-api/create-document/',//{devis_id} 
    getListDemandValidationSign: API + 'api/sign-api/liste-document-sans-contrat',
    storeDocumentValidate: API + 'api/sign-api/store-document-agreement/',//{devis_id} 
    postDevisSigned: API + 'api/sign-api/status-document-devis',

    postAcceptDevis: API + 'api/validate-devis-client/',//{devi_id} 
    postDenyDevis: API + 'api/refuser-devis-client/',//{devi_id} 
    postUploadLogo: API + 'admin/devis-option/',//{user_id} 
    postCancelDevis: API + 'api/cancel-devis-pro/',//{devi_id} 

    getDocSigned: 'https://api.eu1.adobesign.com/api/rest/v6/agreements/', //{agreement_id_variable_devis}/combinedDocument/url

    getDetailFacture: API + 'api/get-facture-detail/', //{facture_id}
    getPaymentByBank: API + 'api/valider-paiement-facture/', //{facture_id}
    postPayment: API + 'api/paiement/checkout/', //{facture_id}
    getListPayment: API + 'api/paiement/lists/', //{user_id}
    getStatePayment: API + 'api/paiement/authorize/', //{paiement_id}/{facture}
}
